import $ from 'jquery';
import 'select2';

const settings = {
  theme: 'classic',
  language: {
    noResults: function () {
      return 'Nenhum resultado encontrado.';
    },
  },
  escapeMarkup: function (markup) {
    return markup;
  },
};

export const stateCity = () => {
  $('.js-states')
    .select2({
      ...settings,
    })
    .on('change', function (e) {
      var post = {};

      post.id = e.target.value;
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/estados/busca-cidades/' + post.id;

      $.ajax({
        type: 'GET',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
      }).then(function (data) {
        $('.js-cities').empty();

        $.each(data, function (index, element) {
          var option = new Option(element, index);
          $('.js-cities').append(option);
        });
      });
    });

  $('.js-cities').select2({
    ...settings,
  });
};

export const area = () => {
  $('.js-areas').select2({
    placeholder: 'Informe a sua área',
    ...settings,
  });
};

export const unity = () => {
  const dfOpt = new Option('Informe sua loja', '');

  $('.js-unities')
    .select2({
      placeholder: 'Informe seu distrito',
      ...settings,
    })
    .on('change', function (e) {
      if (e.target.value) {
        var post = {};
        post.id = e.target.value;
        post._token = $('meta[name="csrf-token"]').attr('content');

        var url = '/distrito/busca-lojas/' + post.id;

        $.ajax({
          type: 'GET',
          url: url,
          data: post,
          cache: false,
          dataType: 'json',
        }).then(function (data) {
          $('.js-stores').select2({
            placeholder: 'Informe sua loja',
            ...settings,
          });

          $('.js-stores').empty().append(dfOpt);

          $.each(data, function (index, element) {
            var option = new Option(element, index);
            $('.js-stores').append(option);
          });
        });
      }
    });
};

export const stores = () => {
  $('.js-stores').select2({
    placeholder: 'Primeiro informe seu distrito',
    ...settings,
  });
};

export const activities = () => {
  $('.js-activities').select2({
    placeholder: 'Selecione e etapa',
    ...settings,
  });
};

export const cdType = () => {
  $('.js-cd-type').select2({
    placeholder: 'Selecione',
    ...settings,
  });
};

export const funcional = () => {
  $('.js-funcional').select2({
    placeholder: 'Informe seu cargo',
    ...settings,
  });
};

export const funcionalByWorkplace = () => {
  funcional();

  const dfOpt = new Option('Informe seu cargo', '');

  $('.js-workplace').on('change', function (e) {
    let id = e.target.value == 2 || e.target.value == 'ec' ? 'ec' : 'store';

    $.ajax({
      type: 'GET',
      url: `/cargos/${id}`,
      data: {
        id: id,
        _token: $('meta[name="csrf-token"]').attr('content'),
      },
      cache: false,
      dataType: 'json',
      success: function (data) {
        if (data) {
          $('.js-funcional').empty().append(dfOpt);

          $.each(data, function (index, element) {
            var option = new Option(element, index);
            $('.js-funcional').append(option);
          });
        }
      },
    });
  });
};

export const categories = () => {
  $('.js-category').select2({
    multiple: true,
    ...settings,
  });
};

export const plurals = () => {
  $('.js-plural').select2({
    multiple: true,
    ...settings,
  });
};

export const organizations = () => {
  $('.js-organization').select2({
    placeholder: 'Selecione a organização',
    ...settings,
  });
};

export const resetAreaValue = () => {
  $('.js-areas').val('').trigger('change');
};

export const resetStatesValue = () => {
  $('.js-states').val('').trigger('change');
};

export const resetCitiesValue = () => {
  $('.js-cities').val('').trigger('change');
};

export const resetUnitiesValue = () => {
  $('.js-unities').val('').trigger('change');
};

export const resetStoresValue = () => {
  $('.js-stores').val('').trigger('change');
};

export const resetActivitiesValue = () => {
  $('.js-activities').val('').trigger('change');
};

export const resetCdTypeValue = () => {
  $('.js-cd-type').val('').trigger('change');
};

export const resetFuncionalValue = () => {
  $('.js-funcional').val('').trigger('change');
};

export const resetCategoryValue = () => {
  $('.js-category').val('').trigger('change');
};

export const resetPluralValue = () => {
  $('.js-plural').val('').trigger('change');
};

export const resetOrganizationValue = () => {
  $('.js-organization').val('').trigger('change');
};
